import React, { useEffect } from "react";
import items from "./faqs.json";

const Faqs: React.FC = () => {
  useEffect(() => {
    document.title = "FAQ | LensTalk";
  }, []);

  return (
    <div className="container mt-5">
      <h1 className="mb-4 text-primary">FAQs</h1>
      <div className="accordion" id="faqAccordion">
        {Object.entries(items).map(([question, answer], index) => (
          <div className="accordion-item" key={index}>
            <h2 className="accordion-header" id={`heading-${index}`}>
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapse-${index}`}
                aria-expanded="false"
                aria-controls={`collapse-${index}`}
              >
                {question}
              </button>
            </h2>
            <div
              id={`collapse-${index}`}
              className="accordion-collapse collapse"
              aria-labelledby={`heading-${index}`}
              data-bs-parent="#faqAccordion"
            >
              <div className="accordion-body">
                <div dangerouslySetInnerHTML={{ __html: answer }}></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faqs;
